import _ from "lodash";
import "babel-polyfill";
// import "./bootstrap";

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
import "vue-resource";

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.css";
import sweetAlert from "sweetalert";
import elementui from "element-plus";
import collect from "collect.js";

window._ = _;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import $ from "jquery";
window.$ = window.jQuery = $;
// import 'bootstrap';

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.toastr = toastr;
window.toastr.options.progressBar = true;
window.toastr.options.closeButton = true;
window.toastr.options.preventDuplicates = true;
window.toastr.options.timeOut = 10000;

window.sweetAlert = sweetAlert;

window.elementui = elementui;

window.collect = collect;
